/* eslint-disable react/jsx-props-no-spreading */

'use client';

import type * as React from 'react';
import type { CSSTransitionProps } from 'react-transition-group/CSSTransition';

import { DeprecatedBadge } from '@coop/components';
import classNames from 'classnames';
import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import styles from './AnimatedBadge.module.scss';

const AnimatedBadge = (
    props: React.PropsWithChildren<React.ComponentProps<typeof DeprecatedBadge>> & {
        animationProps: CSSTransitionProps;
    },
) => {
    const isUpdatingAndActive = classNames(styles['is-updating'], styles['is-active']);
    const isActive = styles['is-active'];

    const transitionRef = useRef(null);

    const { key, ...animProps } = props.animationProps;

    return (
        <CSSTransition
            nodeRef={transitionRef}
            key={key}
            timeout={0}
            {...animProps}
            classNames={{
                appear: isUpdatingAndActive,
                appearActive: isUpdatingAndActive,
                appearDone: isActive,
                enter: isUpdatingAndActive,
                enterActive: isUpdatingAndActive,
                enterDone: isActive,
            }}
        >
            <DeprecatedBadge ref={transitionRef} {...props} className={styles.Animated} />
        </CSSTransition>
    );
};

export default AnimatedBadge;
